export default __webpack_public_path__ + "static/media/plus.f5d4d283.png";